import React from "react";
import { connect } from "react-redux";
import { SaveInArchive } from "../../../actions/stydyYear.action";
import {FileZipOutlined } from "@ant-design/icons"
import { Popconfirm, message } from 'antd';

const SaveToArchive = ({ SaveInArchive, id }) => {
  function confirm(e) {
    SaveInArchive(id);
    message.success('تم أرشفة العام الدراسي');
  }
  
  function cancel(e) {
    console.log(e);
    message.error('تم إلغاء العملية');
  }


  return (
    <Popconfirm
    title="هل انت متأكد من ذلك"
    onConfirm={confirm}
    onCancel={cancel}
    okText="نعم"
    cancelText="لا"
  >
    {/* eslint-disable-next-line */}
    <a className="lesson-config" href="#"><FileZipOutlined /></a>
  </Popconfirm>

  );
};
export default connect(null, {
  SaveInArchive,
})(SaveToArchive);
